import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=9362c7d2&scoped=true"
import script from "./HistoryView.vue?vue&type=script&lang=ts"
export * from "./HistoryView.vue?vue&type=script&lang=ts"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=9362c7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9362c7d2",
  null
  
)

export default component.exports